<div class="forbidden-container">
  <div class="forbidden-content">
    <mat-icon class="forbidden-icon">block</mat-icon>
    <h1 class="forbidden-title">Access Denied</h1>
    <p class="forbidden-message">
      You don't have permission to access this resource.
    </p>
    <div class="forbidden-actions">
      <button ni-button 
              [view]="'accent'" 
              [size]="'large'" 
              [outline]="true"
              beforeIcon="fas fa-home"
              (click)="goHome()">
        Go Home
      </button>
      <button ni-button 
              [view]="'info'" 
              [size]="'large'" 
              [outline]="true"
              beforeIcon="fas fa-arrow-left"
              (click)="goBack()">
        Go Back
      </button>
    </div>
  </div>
</div>
